<template>
  <div class="trail-show" v-if="showTrail">
    <div class="hero">
      <TrailListItemMedia :item="trail" />
    </div>
    <div class="main">
      <div class="section header">
        <TrailShowHeader :trail="trail" />
      </div>
      <div class="section content">
        <TrailShowContent :trail="trail" />
      </div>
      <div class="section params">
        <TrailShowParams :trail="trail" />
      </div>
      <div class="section stack">
        <h2 class="title">技术</h2>
        <TrailShowStack :trail="trail" />
      </div>
      <div class="section track">
        <h2 class="title">行程</h2>
        <TrailShowTrack :trail="trail" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters, mapActions } from 'vuex';
import TrailListItemMedia from '@/trail/index/components/trail-list-item-media';
import TrailShowHeader from '@/trail/show/components/trail-show-header';
import TrailShowContent from '@/trail/show/components/trail-show-content';
import TrailShowParams from '@/trail/show/components/trail-show-params';
import TrailShowTrack from '@/trail/show/components/trail-show-track';
import TrailShowStack from '@/trail/show/components/trail-show-stack';

export default defineComponent({
  name: 'TrailShow',

  /**
   * 标题
   */
  title() {
    if (this.showTrail) {
      return this.trail.title;
    } else {
      return '加载中...';
    }
  },

  /**
   * 属性
   */
  props: {
    trailId: String,
  },

  /**
   * 数据
   */
  data() {
    return {};
  },

  /**
   * 计算属性
   */
  computed: {
    ...mapGetters({
      loading: 'trail/show/loading',
      trail: 'trail/show/trail',
    }),

    showTrail() {
      return !this.loading && this.trail;
    },
  },

  /**
   * 已创建
   */
  async created() {
    await this.getTrailById(this.trailId);
  },

  /**
   * 组件方法
   */
  methods: {
    ...mapActions({
      getTrailById: 'trail/show/getTrailById',
    }),
  },

  /**
   * 使用组件
   */
  components: {
    TrailShowStack,
    TrailShowTrack,
    TrailShowContent,
    TrailShowHeader,
    TrailListItemMedia,
    TrailShowParams,
  },
});
</script>

<style scoped>
@import './styles/trail-show.css';
</style>
